import { Public_Routes } from '@common/url';
import { navigateAndRefresh } from '@prophecy/utils/history';

export const redirectToAuth = (redirect = window.location.href) => {
  navigateAndRefresh(Public_Routes.SignIn.getUrl(undefined, { redirect }));
};
